import { cx } from "class-variance-authority";
import React from "react";

/**
 * @deprecated in FloKit
 */
export type StatusChipVariant =
  | "none"
  | "default"
  | "green"
  | "gray"
  | "yellow"
  | "red"
  | "blue"
  | "teal";

interface StatusChipProps {
  children?: string | React.ReactNode;
  variant?: StatusChipVariant;
  className?: string;
}

const variants: Record<StatusChipVariant, string> = {
  none: "text-macbook",
  default: "bg-friendly-eskimo text-charcoal",
  green: "bg-accent-success text-accent-on-success",
  gray: "bg-bright-gray text-medium-hippo",
  yellow: "bg-accent-warning text-accent-on-warning",
  red: "bg-accent-error text-accent-on-error",
  blue: "bg-accent-positive text-accent-on-positive",
  teal: "bg-accent-progress text-accent-on-progress",
};

/**
 * @deprecated in FloKit
 */
export const StatusChip = React.forwardRef<HTMLDivElement, StatusChipProps>(
  (props: StatusChipProps, ref) => {
    return (
      <span
        className={cx(
          "w-fit-content inline-block w-fit rounded-2xl px-3 py-1 leading-4",
          "text-sm font-semibold",
          variants[props.variant ?? "default"],
          props.className,
        )}
        {...ref}
      >
        {props.children}
      </span>
    );
  },
);

export const StatusBlock = React.forwardRef<HTMLDivElement, StatusChipProps>(
  (props, ref) => {
    return (
      <div
        ref={ref}
        className={cx(
          "rounded-lg",
          "p-4",
          variants[props.variant ?? "default"],
          props.className,
        )}
      >
        {props.children}
      </div>
    );
  },
);
